import { LayaGL } from "../../layagl/LayaGL";
import { Shader3D } from "../../RenderEngine/RenderShader/Shader3D";
export class Scene2DSpecialManager {
    constructor() {
        this.componentElementMap = new Map();
        this._shaderData = LayaGL.renderDeviceFactory.createShaderData(null);
        if (!Scene2DSpecialManager.SPRITE2DGLOBAL) {
            Scene2DSpecialManager.SPRITE2DGLOBAL = Shader3D.getDefineByName("SPRITE2DGLOBAL");
        }
        this._shaderData.addDefine(Scene2DSpecialManager.SPRITE2DGLOBAL);
    }
}
